import { useFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/flowsConfigureStore';

interface HookResponse {
  handleSelectAll: (items: string[]) => void;
  handleDeselectAll: () => void;
}

type Page = 'insurances' | 'companies' | 'coverages';

const useFlowsConfigureSelectAllButtonProps = (
  page: Page,
  insuranceId?: string,
): HookResponse => {
  const setCompanies = useFlowsConfigureStore((state) => state.setCompanies);
  const setInsurances = useFlowsConfigureStore((state) => state.setInsurances);
  const setCoverages = useFlowsConfigureStore((state) => state.setCoverages);

  const handleSelectAll = (items: string[]) => {
    if (page === 'companies') {
      setCompanies(insuranceId || '', items);
    } else if (page === 'insurances') {
      setInsurances(items);
    } else if (page === 'coverages') {
      setCoverages(insuranceId || '', items);
    }
  };

  const handleDeselectAll = () => {
    if (page === 'companies') {
      setCompanies(insuranceId || '', []);
    } else if (page === 'insurances') {
      setInsurances([]);
    } else if (page === 'coverages') {
      setCoverages(insuranceId || '', []);
    }
  };

  return {
    handleSelectAll,
    handleDeselectAll,
  };
};

export default useFlowsConfigureSelectAllButtonProps;
